import script from "./report-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-chart.vue?vue&type=script&lang=ts&setup=true"

import "./report-chart.vue?vue&type=style&index=0&id=6c7940d0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7940d0"]])

export default __exports__